// Format date for display
export const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

// Format currency values safely
export const formatCurrency = (value) => {
    if (value === undefined || value === null) return "0.00";
    const numValue = typeof value === "string" ? parseFloat(value) : value;
    return isNaN(numValue) ? "0.00" : numValue.toFixed(2);
};

// Format customer name
export const getCustomerName = (order, t = null) => {
    if (!order) return "";

    if (order.customerInfo) {
        return `${order.customerInfo.firstName || ""} ${order.customerInfo.lastName || ""
            }`.trim();
    } else if (order.billingInfo) {
        return `${order.billingInfo.firstName || ""} ${order.billingInfo.lastName || ""
            }`.trim();
    } else if (order.customer?.name) {
        return order.customer.name;
    }

    return t ? t('guest') : "Guest";
};

// Format payment method
export const formatPaymentMethod = (method, t = null) => {
    if (!method) return t ? t('paymentNotAvailable') : "N/A";

    if (t) {
        // Use translations if available
        switch (method) {
            case 'cash_on_delivery':
                return t('cashOnDelivery');
            case 'credit_card':
                return t('creditCard');
            case 'hosted_checkout':
                return t('hostedCheckout') || 'Online Payment';
            case 'manual_transfer':
                return t('directBankTransfer') || 'Bank Transfer';
            case 'paypal':
                return t('paypal');
            case 'apple_pay':
                return t('applePay');
            default:
                // Convert snake_case to Title Case as fallback
                return method.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
        }
    }

    // Convert snake_case to Title Case
    return method.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
};